import { useState } from "react";
import Additional_apporval from "./Additional_apporval";
import Vendor_payment from "./vendor_payment";
import { useLocation } from "react-router-dom";
import Addition_Apporval_edit from "./Addition_apporval_edit";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";

export default function Finance_Dependent({
  dependentDetails,
  setTrigger,
  trigger,
  setIndex,
  setVendorIndex,
}) {
  const [subIndex, setSubIndex] = useState(0);
  const handleSubIndexChange = (value) => {
    setSubIndex(value);
  };
  const [locationState, setLocationState] = useState(false);

  const location = useLocation();
  useEffect(() => {
    if (location.pathname.split("/")[3] === "Additional_apporval") {
      setLocationState(true);
    } else {
      setLocationState(false);
    }
  }, [location]);
  const [details, setDetails] = useState();
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const [fileter, setFilter] = useState("");
  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/excelDownload/FINANCE`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `OPS_2_REPORT_FINANCE`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  console.log("filter date should be poppulated here....",fileter)
  const formattedInputDate = fileter ? formatDate(fileter) : "";
  return (
    <>
      {locationState ? (
        <Addition_Apporval_edit
          details={details}
          setTrigger={setTrigger}
          trigger={trigger}
          setIndex={setIndex}
        />
      ) : (
        <div className="mt-4 w-[95%] mx-auto">
          <div className="flex ">
            <button
              className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${subIndex == 0 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
              onClick={() => {
                handleSubIndexChange(0);
                // setVendorIndex(0)
                setVendorIndex("");
              }}
            >
              DEPENDENT ADDITION APPROVAL
            </button>

            <button
              className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${subIndex == 1 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
              onClick={() => {
                handleSubIndexChange(1);
                setVendorIndex("VENDOR");
              }}
            >
              VENDOR PAYMENT
            </button>
          </div>
          {subIndex === 0 ? (
            <Additional_apporval
              dependentDetails={dependentDetails}
              setTrigger={setTrigger}
              trigger={trigger}
              setIndex={setIndex}
              titles={[
                "S.NO",
                "REQUEST TYPE",
                "NO OF DEPENDENTS",
                "EMP NAME",
                "EMP ID",
                "GENDER",
                "NATIONALITY",
                "ACTUAL PROFESSION",
                "CLIENT NAME",
                "IQAMA NUMBER",
                "IQAMA EXPIRY DATE",
                "PROJECT NAME",
                "INSURANCE CLASS",
                "ACTION",
              ]}
              setDetails={setDetails}
            />
          ) : subIndex === 1 ? (
            <Vendor_payment
              dependentDetails={dependentDetails}
              setTrigger={setTrigger}
              trigger={trigger}
              setIndex={setIndex}
              titles={[
                "S.NO",
                "DEPENDENT NAME",
                "DATE OF BIRTH",
                "DEPENDENT IQAMA NUMBER",
                "RELATION",
                "CLASS",
                "GENDER",
                "HEAD OF FAMILY",
                "INSURANCE APPLY DATE",
                "AMOUNT PAID",
                "INVOICE NUMBER",
                "ACTION",
              ]}
              setDetails={setDetails}
            />
          ) : (
            <Additional_apporval
              dependentDetails={dependentDetails}
              setTrigger={setTrigger}
              trigger={trigger}
              setIndex={setIndex}
              titles={[
                "S.NO",
                "REQUEST TYPE",
                "NO OF DEPENDENTS",
                "EMP NAME",
                "EMP ID",
                "GENDER",
                "NATIONALITY",
                "ACTUAL PROFESSION",
                "CLIENT NAME",
                "IQAMA NUMBER",
                "IQAMA EXPIRY DATE",
                "PROJECT NAME",
                "INSURANCE CLASS",
                "ACTION",
              ]}
              setDetails={setDetails}
            />
          )}
        </div>
      )}
    </>
  );
}
